module.exports = __webpack_public_path__ + "static/img/ikonaWWW-ON.ee5c3a47.png";